import { computed, reactive, watch } from "vue";

import { contact, portalStore, value } from "store/portal";
import { department } from "store/department";

import { env } from "config";
import { cache, initCache, clearCache } from "helpers/_cache";

// Defineour defaults and restore the data
const cacheableValues = {
	active: undefined
};
const companyDefaults = {
	...cacheableValues
};
export const companyStore = reactive({
	loading: true,
	...companyDefaults
});
Object.keys(cacheableValues).forEach((key) => {
	initCache("company", key, companyStore);
});

// Export our computed properties
export const companies = computed(() => {
	if (!companyStore.loading) {
		return portalStore.company;
	}
	return [];
});
export const company = computed(() => {
	return department.value?.company || companyStore.active;
});
export const company_id = computed(() => company.value?.data?.id);

export const company_title = computed(() => {
	if (company.value) {
		return value(company.value, env("variables.company.properties.title"));
	}
	if (contact.value && env("variables.contact.properties.company")) {
		return value(contact.value, env("variables.contact.properties.company"));
	}
	return "";
});

// Watchers
// -- Based on value change store active
watch(
	() => companies.value,
	(items) => {
		// If currently no active, set the first one
		if (!companyStore.active && items?.length) {
			companyStore.active = items[0];
		}
	},
	{
		immediate: true
	}
);